import { BoundaryTerritoryGroupConnectedEntities } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import { boundaryTerritoryGroupActivate } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.actionCreators';
import {
  mapSettingsDataLayersAddDataLayer, mapSettingsDataLayersRemoveDataLayer,
} from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.actionCreators';
import type { MapSettingsToolsStateDataLayersAction } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.action';
import { setDataLayersFilter } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.actionCreators';
import type { MapSettingsToolsStateDataLayersState } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.state';

export const mapSettingsToolsStateDataLayersInitialState: MapSettingsToolsStateDataLayersState = {
  activeBTGIdPerBoundaryGroup: {},
  filters: {},
};

type Action =
  MapSettingsToolsStateDataLayersAction
  | ReturnType<typeof boundaryTerritoryGroupActivate>
  | ReturnType<typeof mapSettingsDataLayersAddDataLayer>
  | ReturnType<typeof mapSettingsDataLayersRemoveDataLayer>;

export const mapSettingsToolsStateDataLayersReducer = (state = mapSettingsToolsStateDataLayersInitialState, action: Action): MapSettingsToolsStateDataLayersState => {
  // Only one data layer instance is supported at a time, so its filters are dropped whenever it is replaced or removed.
  if (mapSettingsDataLayersAddDataLayer.match(action) || mapSettingsDataLayersRemoveDataLayer.match(action)) {
    return {
      ...state,
      filters: {},
    };
  }

  if (setDataLayersFilter.match(action)) {
    const { filterKey, filter } = action.payload;

    return {
      ...state,
      filters: {
        ...state.filters,
        [filterKey]: filter,
      },
    };
  }

  if (boundaryTerritoryGroupActivate.match(action)) {
    const { activeBTG: { boundaryGroupId, boundaryTerritoryGroupId, settings: { connectedEntityData } } } = action.payload;

    if (connectedEntityData?.entity !== BoundaryTerritoryGroupConnectedEntities.DataLayer) {
      return state;
    }

    return {
      ...state,
      activeBTGIdPerBoundaryGroup: {
        ...state.activeBTGIdPerBoundaryGroup,
        [boundaryGroupId]: boundaryTerritoryGroupId,
      },
    };
  }

  return state;
};
